import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useToastHelpers } from '@/hooks/use-toast-helpers';
import { SWITCHED_ACCOUNT_NAME_KEY } from '../constants/switched-account';

/**
 * Names the organization the session just entered, once, after a switch reloaded the app.
 */
export function useAccountSwitchedToast() {
  const { t } = useTranslation();
  const { showSuccess } = useToastHelpers();

  useEffect(() => {
    const name = sessionStorage.getItem(SWITCHED_ACCOUNT_NAME_KEY);
    if (!name) return;

    // Cleared before showing, so a later reload does not repeat it.
    sessionStorage.removeItem(SWITCHED_ACCOUNT_NAME_KEY);
    showSuccess(t('features.auth.switchAccount.switched', { name }));
    // Runs on mount only — the stored name is a one-shot handoff, not reactive state.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
